/* Simple Lift — theme JS (enhanced shop + add-to-cart) */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ── Toast ────────────────────────────────────────────────
  const toast = (msg, error = false) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('error', !!error);
    el.classList.add('show');
    clearTimeout(window.__toastT);
    window.__toastT = setTimeout(() => el.classList.remove('show'), 2600);
  };

  // ── Cart drawer ───────────────────────────────────────────
  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-cart-scrim]');
  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('open');
    if (scrim) scrim.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // Cart drawer: trap keyboard focus while open
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const dr = $('[data-cart-drawer]');
    if (!dr || dr.getAttribute('aria-hidden') !== 'false') return;
    const foc = dr.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!foc.length) return;
    const first = foc[0], last = foc[foc.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Mobile nav toggle
  const burger = $('[data-nav-toggle]');
  const navPanel = $('[data-nav-panel]');
  if (burger && navPanel) {
    burger.addEventListener('click', () => {
      const open = navPanel.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      navPanel.setAttribute('aria-hidden', String(!open));
    });
    navPanel.addEventListener('click', (e) => { if (e.target.closest('a')) { navPanel.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); } });
    window.addEventListener('resize', () => { if (window.innerWidth >= 768 && navPanel.classList.contains('is-open')) { navPanel.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); navPanel.setAttribute('aria-hidden', 'true'); } });
  }

  // ── Money formatter (uses shop money format when available) ──
  const MONEY_FMT = (window.SLTheme && window.SLTheme.moneyFormat) || '${{amount}}';
  const money = (cents) => {
    const n = cents / 100;
    return MONEY_FMT.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, (_, k) =>
      k === '_no_decimals' ? String(Math.round(n)) : k === '_with_comma_separator' ? n.toFixed(2).replace('.', ',') : n.toFixed(2));
  };

  // ── Refresh cart contents (drawer + bubble counts) ────────
  const refreshCart = async () => {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
      const bodyHtml = await fetch('?section_id=cart-drawer-contents').then(r => r.text()).catch(() => null);
      if (bodyHtml) {
        const body = $('[data-cart-body]');
        if (body) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(bodyHtml, 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          body.innerHTML = inner.innerHTML;
          bindLineItems();
        }
      }
      // Cart PAGE table: re-render it too, or qty/remove clicks look dead
      const pageCart = document.getElementById('shopify-section-main-cart');
      if (pageCart) {
        const cartHtml = await fetch('/cart?section_id=main-cart').then(r => r.text()).catch(() => null);
        if (cartHtml) {
          const cdoc = new DOMParser().parseFromString(cartHtml, 'text/html');
          const cinner = cdoc.querySelector('.shopify-section') || cdoc.body;
          pageCart.innerHTML = cinner.innerHTML;
          bindLineItems();
        }
      }
    } catch (e) { if (window.Shopify) console.warn('cart refresh failed', e); }
  };

  // ── Add to cart ───────────────────────────────────────────
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const originalLabel = btn?.innerHTML;
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }
    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Add failed'); }
      const item = await res.json();
      const addedTitle = item.product_title || (item.items && item.items.map(i => i.product_title).join(' + ')) || 'Added';
      toast(`${addedTitle} added`);
      await refreshCart();
      openCart();
    } catch (err) {
      toast(err.message || 'Something went wrong', true);
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = originalLabel || 'Add to bag'; }
    }
  });

  // Product-card buttons sit inside the card's <a> — intercept clicks so the
  // link never hijacks quick-add (Safari) and "Select size" actually navigates
  document.addEventListener('click', (e) => {
    const pick = e.target.closest('[data-quick-pick]');
    if (pick) {
      e.preventDefault();
      const a = pick.closest('a[href]');
      if (a) window.location.href = a.href;
      return;
    }
    const qbtn = e.target.closest('.quick-add [type="submit"]');
    if (qbtn) {
      e.preventDefault();
      const f = qbtn.closest('form');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
    }
  });

  // ── Quantity steppers (drawer line items) ─────────────────
  const bindLineItems = () => {
    $$('[data-qty-up]').forEach(b => b.onclick = async () => {
      const key = b.closest('[data-line-key]')?.dataset.lineKey;
      const input = b.parentNode.querySelector('[data-qty]');
      const next = parseInt(input.textContent, 10) + 1;
      await updateLine(key, next);
    });
    $$('[data-qty-down]').forEach(b => b.onclick = async () => {
      const key = b.closest('[data-line-key]')?.dataset.lineKey;
      const input = b.parentNode.querySelector('[data-qty]');
      const next = Math.max(0, parseInt(input.textContent, 10) - 1);
      await updateLine(key, next);
    });
    $$('[data-line-remove]').forEach(b => b.onclick = async () => {
      const key = b.closest('[data-line-key]')?.dataset.lineKey;
      await updateLine(key, 0);
    });
  };
  const updateLine = async (key, qty) => {
    if (!key) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await refreshCart();
  };
  bindLineItems();

  // ─────────────────────────────────────────────────────────
  // PDP variant switching (borrowed pattern from purchased theme)
  // Build variant lookup map and update id/price when radios change
  // ─────────────────────────────────────────────────────────
  const pdpForm = $('[data-pdp-form]');
  if (pdpForm) {
    const variantJsonEl = pdpForm.querySelector('[data-variant-json]');
    const variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : [];
    const variantIdInput = pdpForm.querySelector('[data-variant-id]');
    const priceLabel = pdpForm.querySelector('[data-pdp-submit-price]');
    const submitLabel = pdpForm.querySelector('[data-pdp-submit-label]');
    const submitBtn = pdpForm.querySelector('[data-pdp-submit]');
    const mainPrice = $('[data-pdp-price-amount]');
    const editionBar = $('.pdp-edition');

    const getSelected = () => {
      const groups = pdpForm.querySelectorAll('[data-option-group]');
      const sel = [];
      groups.forEach(g => {
        const checked = g.querySelector('input[type="radio"]:checked');
        sel.push(checked ? checked.value : null);
      });
      return sel;
    };

    const findVariant = (selected) => variants.find(v => {
      return v.options.every((opt, i) => opt === selected[i]);
    });

    const updatePicked = (group, value) => {
      const picked = group.querySelector('[data-picked]');
      if (picked) picked.textContent = value;
      // Update visual selected class
      group.querySelectorAll('.opt').forEach(o => {
        const isSel = o.dataset.optionValue === value;
        o.classList.toggle('selected', isSel);
      });
    };

    const refreshVariant = () => {
      const sel = getSelected();
      // Update each group's picked label
      pdpForm.querySelectorAll('[data-option-group]').forEach((g, i) => {
        if (sel[i]) updatePicked(g, sel[i]);
      });
      const v = findVariant(sel);
      if (!v) {
        if (submitLabel) submitLabel.innerHTML = 'Unavailable';
        if (submitBtn) submitBtn.disabled = true;
        return;
      }
      if (variantIdInput) variantIdInput.value = v.id;
      if (mainPrice) mainPrice.textContent = money(v.price);
      if (v.available) {
        if (submitBtn) submitBtn.disabled = false;
        if (submitLabel) submitLabel.innerHTML = `Add to bag — <span data-pdp-submit-price>${money(v.price)}</span>`;
      } else {
        if (submitBtn) submitBtn.disabled = true;
        if (submitLabel) submitLabel.innerHTML = 'Sold out';
      }
      // Update URL (?variant=XXX) so refresh keeps selection
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    };

    pdpForm.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"][data-variant-radio]')) {
        refreshVariant();
      }
    });

    // Click on opt label should also trigger
    pdpForm.querySelectorAll('.opt').forEach(opt => {
      opt.addEventListener('click', () => {
        const input = opt.querySelector('input[type="radio"]');
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    // ── PDP qty stepper ────────────────────────────────────
    const qtyInput = pdpForm.querySelector('[data-pdp-qty]');
    if (qtyInput) {
      const fixQty = () => { const v = parseInt(qtyInput.value, 10); qtyInput.value = (!v || v < 1) ? 1 : Math.min(v, 99); };
      fixQty();
      qtyInput.addEventListener('change', fixQty);
      window.addEventListener('pageshow', fixQty);
    }
    pdpForm.querySelectorAll('[data-qty-step]').forEach(b => {
      b.addEventListener('click', () => {
        const step = parseInt(b.dataset.qtyStep, 10) || 1;
        const cur = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, cur + step);
      });
    });
  }

  // ─────────────────────────────────────────────────────────
  // PDP gallery — click thumb to swap main image
  // ─────────────────────────────────────────────────────────
  const gallery = $('[data-pdp-gallery]');
  if (gallery) {
    const mainImg = gallery.querySelector('#pdp-main-img');
    gallery.querySelectorAll('[data-thumb]').forEach(btn => {
      btn.addEventListener('click', () => {
        gallery.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (mainImg) mainImg.src = btn.dataset.full;
      });
    });
  }

  // ─────────────────────────────────────────────────────────
  // Related products via Shopify API
  // ─────────────────────────────────────────────────────────
  const related = $('[data-related-products]');
  if (related) {
    const productId = related.dataset.productId;
    const grid = related.querySelector('[data-related-grid]');
    fetch(`/recommendations/products?section_id=related-products&product_id=${productId}&limit=4`)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cards = doc.querySelectorAll('.product');
        if (cards.length === 0) { related.style.display = 'none'; return; }
        cards.forEach(c => grid.appendChild(c));
      })
      .catch(() => { related.style.display = 'none'; });
  }

  // ─────────────────────────────────────────────────────────
  // Sticky ATC (mobile) — borrowed from purchased theme pattern
  // Shows when user scrolls past the main PDP form, hides at footer
  // ─────────────────────────────────────────────────────────
  const stickyAtc = $('[data-sticky-atc]');
  const pdpAnchor = $('[data-pdp-form]');
  if (stickyAtc && pdpAnchor) {
    let visible = false;
    const update = () => {
      const anchorBottom = pdpAnchor.getBoundingClientRect().bottom;
      const shouldShow = anchorBottom < 80;
      if (shouldShow !== visible) {
        visible = shouldShow;
        stickyAtc.classList.toggle('sticky-atc--out', !shouldShow);
      }
    };
    let saTick = false;
    window.addEventListener('scroll', () => { if (!saTick) { saTick = true; requestAnimationFrame(() => { update(); saTick = false; }); } }, { passive: true });
    update();
  }

  // ─────────────────────────────────────────────────────────
  // Quick-add buttons on product cards (default-variant products)
  // ─────────────────────────────────────────────────────────
  // Already handled by generic [data-add-form] submit handler.

  // "Select size" buttons go to PDP — keep default link behavior

  // ─────────────────────────────────────────────────────────
  // Collection sort — auto-submit sort form on change
  // ─────────────────────────────────────────────────────────
  $$('[data-sort-select]').forEach(sel => {
    sel.addEventListener('change', () => sel.form.submit());
  });

  // ─────────────────────────────────────────────────────────
  // Partner pathway tabs (homepage)
  // ─────────────────────────────────────────────────────────
  $$('[data-pathway-tab]').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.pathwayTab;
      $$('[data-pathway-tab]').forEach(t => t.classList.toggle('on', t === tab));
      $$('[data-pathway-panel]').forEach(p => p.classList.toggle('hidden', p.dataset.pathwayPanel !== target));
      const labelMap = {
        ambassador: { label: 'Instagram / public profile', ph: '@yourhandle or link' },
        wholesale:  { label: 'Store / retailer name',     ph: 'e.g. Marrickville Strength Co.' },
        stockist:   { label: 'Gym / studio name',          ph: 'e.g. Bondi Barbell Co.' },
      };
      const lbl = labelMap[target];
      if (lbl) {
        const label = $('[data-pathway-field-label]');
        const input = $('[data-pathway-field-input]');
        if (label) label.textContent = lbl.label;
        if (input) input.setAttribute('placeholder', lbl.ph);
      }
    });
  });

  // ─────────────────────────────────────────────────────────
  // Marquee, reveal, soft forms (unchanged)
  // ─────────────────────────────────────────────────────────
  $$('[data-marquee]').forEach(track => { track.innerHTML += track.innerHTML; });

  // ─────────────────────────────────────────────────────────
  // SCROLL ANIMATION ENGINE
  // Respects prefers-reduced-motion: if the user opts out, every
  // animated element is shown immediately and no observers run.
  // ─────────────────────────────────────────────────────────
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Auto-tag known child containers so they stagger their children in.
  const STAGGER_SELECTORS = [
    '.grid', '.chalk-grid', '.process-steps', '.locations-list',
    '.reviews-strip', '.partners-pathways', '.soon-list', '.benefits',
    '.hero-left', '.footer-cols'
  ];
  STAGGER_SELECTORS.forEach(sel => {
    $$(sel).forEach(el => { if (!el.hasAttribute('data-stagger')) el.setAttribute('data-stagger', ''); });
  });

  if (reduceMotion) {
    // Show everything, skip all motion.
    $$('.reveal, [data-stagger]').forEach(el => el.classList.add('in-view'));
    const mh = $('[data-mathero]'); if (mh) mh.classList.add('is-in');
    document.documentElement.classList.add('sl-no-motion');
  } else {
    document.documentElement.classList.add('sl-anim-ready');

    // ── Reveal + stagger observer ──────────────────────────
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(en => {
          if (en.isIntersecting) {
            en.target.classList.add('in-view');
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      $$('.reveal, [data-stagger]').forEach(el => io.observe(el));
    } else {
      $$('.reveal, [data-stagger]').forEach(el => el.classList.add('in-view'));
    }

    // ── Parallax (subtle drift on tagged media) ────────────
    const parallaxEls = $$('[data-parallax]');
    if (parallaxEls.length) {
      let ticking = false;
      const applyParallax = () => {
        const vh = window.innerHeight;
        parallaxEls.forEach(el => {
          const speed = parseFloat(el.dataset.parallax) || 0.12;
          const rect = el.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > vh + 200) return;
          const center = rect.top + rect.height / 2;
          const offset = (center - vh / 2) * speed * -1;
          el.style.setProperty('--parallax', offset.toFixed(1) + 'px');
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { window.requestAnimationFrame(applyParallax); ticking = true; }
      }, { passive: true });
      applyParallax();
    }

    // ── SCROLLER: pinned product, scene-by-scene (Oryzo-style) ──
    const scroller = $('[data-scroller]');
    if (scroller) {
      const ink   = scroller.querySelector('[data-sc-ink]');
      const mat   = scroller.querySelector('[data-sc-mat]');
      const beam = scroller.querySelector('[data-sc-beam]');
      const bench = scroller.querySelector('[data-sc-bench]');
      const noirImg = scroller.querySelector('[data-sc-noir]');
      const montImg = scroller.querySelector('[data-sc-mont]');
      const labNoir = scroller.querySelector('[data-sc-label-noir]');
      const labMont = scroller.querySelector('[data-sc-label-mont]');
      const soldBox = scroller.querySelector('[data-sc-soldout]');
      const backBadge = scroller.querySelector('[data-sc-badge]');
      const cornerNoir = scroller.querySelector('[data-sc-corner-noir]');
      const cornerMont = scroller.querySelector('[data-sc-corner-mont]');
      // Playing-card corner index: the holder mirrors its mat's box + transform, the tag sits
      // in the visible top-right corner of the cutout (468×664, object-fit: contain).
      const placeCorner = (holder, img) => {
        if (!holder || !img) return;
        // mirror the image's exact box (a generic .scroller__mat > div width rule would otherwise win)
        const w = img.offsetWidth, h = img.offsetHeight;
        if (!w || !h) return;
        holder.style.setProperty('width', w + 'px', 'important');
        holder.style.setProperty('height', h + 'px', 'important');
        holder.style.setProperty('left', img.offsetLeft + 'px', 'important');
        holder.style.setProperty('top', img.offsetTop + 'px', 'important');
        holder.style.setProperty('right', 'auto', 'important');
        holder.style.setProperty('bottom', 'auto', 'important');
        holder.style.transform = img.style.transform || getComputedStyle(img).transform;
        holder.style.opacity = img.style.opacity || '1';
        const s = Math.min(w / 468, h / 664), vw = 468 * s, vh = 664 * s;
        const tag = holder.firstElementChild;
        tag.style.right = ((w - vw) / 2 + vw * 0.06) + 'px';
        tag.style.top = ((h - vh) / 2 + vh * 0.035) + 'px';
        tag.style.fontSize = Math.max(10, Math.min(18, vw * 0.055)).toFixed(1) + 'px';
      };
      const placeSold = () => {
        placeCorner(cornerNoir, noirImg);
        placeCorner(cornerMont, montImg);
        if (backBadge && noirImg) {
          const br = backBadge.parentElement.getBoundingClientRect();
          const r = noirImg.getBoundingClientRect();
          if (r.height) {
            const matW = r.height * 0.705;
            // pin to the mat's visible top-right corner (cutout is centred in the box)
            backBadge.style.setProperty('left', (r.left - br.left + r.width / 2 + matW / 2 - 6) + 'px', 'important');
            backBadge.style.setProperty('top', (r.top - br.top + r.height * 0.08) + 'px', 'important');
            backBadge.style.opacity = noirImg.style.opacity || '1';
          }
        }
        if (!soldBox || !noirImg) return;
        const sr = soldBox.parentElement.getBoundingClientRect();
        const r = noirImg.getBoundingClientRect();
        if (!r.height) return;
        const matW = r.height * 0.705;
        soldBox.style.setProperty('left', (r.left - sr.left + r.width / 2) + 'px', 'important');
        soldBox.style.setProperty('top', (r.top - sr.top + r.height / 2) + 'px', 'important');
        soldBox.style.setProperty('font-size', Math.max(16, Math.min(72, matW * 0.19)).toFixed(1) + 'px', 'important');
        soldBox.style.opacity = noirImg.style.opacity || '1';
      };
      const halo = scroller.querySelector('[data-sc-halo]');
      const disc = scroller.querySelector('[data-sc-disc]');
      const scenes = Array.from(scroller.querySelectorAll('[data-scene]'));
      const n = scenes.length;
      const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
      let sTick = false;
      let scrollerLabelsShown = false;
      let matState = { dropY: 0, tilt: 0, rotZ: 0, scale: 1 };
      // idle float/bob removed — the mat only follows the scroll pose (set at the end of onScroll)
      let lastP = -1;
      let vhCache = window.innerHeight, vwCache = window.innerWidth;
      const applyFrame = (p) => {

        // Background turns to ink after the opening (cream) scene
        if (ink) ink.style.opacity = clamp((p - 0.16) / 0.10, 0, 1).toFixed(3);
        if (beam) beam.style.opacity = (1 - clamp((p - 0.7) / 0.14, 0, 0.35)).toFixed(3);

        // Final scene: bench fades in and the mat settles onto it
        const settle = clamp((p - 0.74) / 0.24, 0, 1);
        if (bench) bench.style.opacity = settle.toFixed(3);

        // Mat: gentle scale + rotation + tilt; then settles flat onto the bench
        const scale = (1 + p * 0.34) * (1 - settle * 0.18);
        const rotZ = Math.sin(p * Math.PI) * 6 * (1 - settle);
        const tiltMid = Math.sin(p * Math.PI) * 16;
        const tilt = tiltMid * (1 - settle);                  // flattens upright as mats pair
        const dropY = settle * ((vwCache <= 760) ? vhCache * 0.17 : -30); // phones: settle low, clear of the text
        matState = { dropY, tilt, rotZ, scale };

        // Noir leads the scroll; at the bench, both colourways rest side by side
        const pair = settle; // ramps 0→1 across the final "On your bench" scene
        const mobileHero = window.innerWidth <= 760;
        // images are centre-anchored (left:50% + -50%); the split shifts off that centre
        const sx = mobileHero ? (20 * pair).toFixed(2) + 'vw' : (116 * pair).toFixed(1) + '%';
        const pairScale = mobileHero ? (1 - 0.40 * pair) : (1 + 0.12 * pair);
        // Opening: both mats fanned like a hand of cards (Noir in front, Blanc Lite peeking out
        // behind to the right). The fan closes into the single Noir mat as the scroll starts.
        // At rest the fan is tight (Blanc Lite just peeks out); it opens as the scroll runs,
        // then hands over to the side-by-side pairing in the final scene.
        const open = clamp(p / 0.45, 0, 1);
        const fan = 1 - pair;
        const fanRot = (mobileHero ? 6 + 8 * open : 6 + 10 * open) * fan;
        const fanShift = (mobileHero ? 10 + 14 * open : 12 + 30 * open) * fan;   // % of the mat's own width
        const fanScale = 1 - (mobileHero ? 0.12 : 0.06) * fan;
        if (noirImg) {
          noirImg.style.opacity = '1';
          noirImg.style.transform = `translateX(calc(-50% - ${sx} - ${(fanShift * 0.3).toFixed(2)}%)) rotate(${(-fanRot * 0.35).toFixed(2)}deg) scale(${(pairScale * fanScale).toFixed(3)})`;
        }
        if (montImg) {
          montImg.style.opacity = '1';
          montImg.style.transform = `translateX(calc(-50% + ${sx} + ${fanShift.toFixed(2)}%)) translateY(${(fan * 1.5).toFixed(2)}%) rotate(${fanRot.toFixed(2)}deg) scale(${(pairScale * fanScale).toFixed(3)})`;
        }
        // Labels: fade in during the "Two colourways" scene and stay through the bench rest
        // Labels fade in as the two mats separate, so they never collide at centre
        const labFade = clamp((settle - 0.4) / 0.35, 0, 1);
        if (labNoir) labNoir.style.opacity = labFade.toFixed(3);
        if (labMont) labMont.style.opacity = labFade.toFixed(3);
        // Labels ride the bottom edge of their own mat (desktop pinned stage only)
        if (labFade > 0 || scrollerLabelsShown) {
        scrollerLabelsShown = labFade > 0;
        const pinned = mat && getComputedStyle(mat).position === 'absolute';
        const sr = pinned ? mat.parentElement.getBoundingClientRect() : null;
        const ratioOf = (lab) => {
          if (!lab.dataset.wRatio) {
            lab.style.removeProperty('font-size');
            const fs0 = parseFloat(getComputedStyle(lab).fontSize) || 40;
            lab.dataset.wRatio = (lab.scrollWidth / fs0).toFixed(4);
          }
          return parseFloat(lab.dataset.wRatio) || 6;
        };
        if (!pinned) {
          [labNoir, labMont].forEach(lab => {
            if (lab) { lab.style.removeProperty('top'); lab.style.removeProperty('left'); lab.style.removeProperty('font-size'); }
          });
        } else if (sr && labNoir && labMont && noirImg && montImg) {
          const rN = noirImg.getBoundingClientRect();
          const rM = montImg.getBoundingClientRect();
          if (rN.height) {
            // cutout is 468×664, object-fit contain in a 3/3.4 box → fits by height
            const matW = rN.height * 0.705;
            // one shared size for the pair, budgeted off the longer wordmark
            const fs = (window.innerWidth <= 760) ? 13 : Math.max(13, Math.min(64, (matW * 0.84) / Math.max(ratioOf(labNoir), ratioOf(labMont))));
            [[labNoir, rN], [labMont, rM]].forEach(([lab, r]) => {
              lab.style.setProperty('font-size', fs.toFixed(1) + 'px', 'important');
              lab.style.setProperty('left', (r.left - sr.left + r.width / 2) + 'px', 'important');
              // fully below the mat's bottom edge, clamped inside the stage
              const top = Math.min(r.bottom - sr.top + 34, sr.height - lab.offsetHeight - 8);
              lab.style.setProperty('top', top + 'px', 'important');
            });
          }
        }
        } // end label guard

        // Contrasting shape layers grow + fade with the scroll
        const inkOp2 = clamp((p - 0.16) / 0.10, 0, 1);
        if (halo) {
          halo.style.transform = `translate(-50%,-50%) scale(${(0.6 + p * 1.2).toFixed(3)}) rotate(${(p * 40).toFixed(1)}deg)`;
          halo.style.opacity = (inkOp2 * 0.5).toFixed(3);
        }
        if (disc) {
          disc.style.transform = `translate(-50%,-50%) scale(${(0.7 + p * 1.0).toFixed(3)})`;
          disc.style.opacity = inkOp2.toFixed(3);
        }

        // Scenes crossfade; first scene is fully visible at rest (p=0), last at p=1
        scenes.forEach((sc, i) => {
          const center = n > 1 ? i / (n - 1) : 0.5;
          const d = Math.abs(p - center) * (n - 1);
          // plateau: fully visible across most of each scene's window, quick fade at edges
          const op = clamp(1.5 - d * 2.2, 0, 1);
          sc.style.opacity = op.toFixed(3);
          sc.style.pointerEvents = op > 0.5 ? 'auto' : 'none';
        });
        // apply the mat's scroll pose
        if (mat) mat.style.transform = `translate(-50%, calc(-50% + ${matState.dropY.toFixed(1)}px)) perspective(900px) rotateX(${matState.tilt.toFixed(2)}deg) rotateZ(${matState.rotZ.toFixed(2)}deg) scale(${matState.scale.toFixed(3)})`;
        requestAnimationFrame(placeSold);
      };
      window.addEventListener('load', placeSold);
      window.addEventListener('resize', placeSold);
      setTimeout(placeSold, 50);
      const onScroll = () => {
        const rect = scroller.getBoundingClientRect();
        const vh = vhCache;
        if (rect.bottom <= 0 || rect.top >= vh) {
          // hero offscreen: settle it once at its edge state, then do no work at all
          const pEdge = rect.bottom <= 0 ? 1 : 0;
          if (lastP !== pEdge) { applyFrame(pEdge); lastP = pEdge; }
          sTick = false; return;
        }
        const total = scroller.offsetHeight - vh;
        const p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
        if (Math.abs(p - lastP) >= 0.0005) { applyFrame(p); lastP = p; }
        sTick = false;
      };
      const safeScroll = () => { try { onScroll(); } catch (err) { sTick = false; } };
      window.addEventListener('scroll', () => { if (!sTick) { sTick = true; requestAnimationFrame(safeScroll); } }, { passive: true });
      const resync = () => { vwCache = window.innerWidth; vhCache = window.innerHeight; lastP = -1; safeScroll(); };
      window.addEventListener('resize', () => {
        if (window.innerWidth === vwCache) return; // height-only resize (URL/tool bars) — never re-sync mid-scroll
        resync();
      }, { passive: true });
      window.addEventListener('orientationchange', () => setTimeout(resync, 300), { passive: true });
      safeScroll();
    }

    // ── ZOOM HERO: scroll zooms into a mat, its colour becomes wallpaper ──
    const zoom = $('[data-zoomhero]');
    if (zoom) {
      const black   = zoom.querySelector('[data-zoom-black]');
      const noir    = zoom.querySelector('[data-zoom-noir]');
      const mont    = zoom.querySelector('[data-zoom-mont]');
      const title   = zoom.querySelector('[data-zoom-title]');
      const capNoir = zoom.querySelector('[data-zoom-cap-noir]');
      const capMont = zoom.querySelector('[data-zoom-cap-mont]');
      const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
      let zTick = false;
      const onZoom = () => {
        const rect = zoom.getBoundingClientRect();
        const total = zoom.offsetHeight - window.innerHeight;
        const p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;

        // Wallpaper: cream → black (Noir fills) → cream (Mont Blanc)
        const blackOp = p < 0.5 ? (p / 0.5) : (1 - (p - 0.5) / 0.5);
        if (black) black.style.opacity = blackOp.toFixed(3);

        // Noir mat: starts small & low so headline reads; zooms in to fill as black wallpaper
        const noirScale = 0.62 + clamp(p / 0.5, 0, 1) * 3.0;
        const noirOp = p < 0.36 ? 1 : clamp(1 - (p - 0.36) / 0.14, 0, 1);
        if (noir) {
          noir.style.transform = `translate(-50%,-50%) scale(${noirScale.toFixed(3)})`;
          noir.style.opacity = noirOp.toFixed(3);
        }

        // Opening title fades quickly as the zoom begins (clear of the mat)
        if (title) title.style.opacity = clamp(1 - p / 0.10, 0, 1).toFixed(3);

        // Mont Blanc: emerges from the black, settles onto cream
        const mP = clamp((p - 0.5) / 0.5, 0, 1);
        const montScale = 2.4 - mP * 1.4;     // starts large (zoomed), settles
        const montOp = clamp((p - 0.46) / 0.12, 0, 1);
        if (mont) {
          mont.style.transform = `translate(-50%,-50%) scale(${montScale.toFixed(3)})`;
          mont.style.opacity = montOp.toFixed(3);
        }

        // Opening title fades as the zoom begins
        if (title) title.style.opacity = clamp(1 - p / 0.16, 0, 1).toFixed(3);

        // Captions
        if (capNoir) capNoir.style.opacity = (p > 0.2 && p < 0.5 ? clamp((p - 0.2) / 0.12, 0, 1) * clamp((0.5 - p) / 0.08, 0, 1) : 0).toFixed(3);
        if (capMont) capMont.style.opacity = (mP > 0.45 ? clamp((mP - 0.45) / 0.25, 0, 1) : 0).toFixed(3);

        zTick = false;
      };
      window.addEventListener('scroll', () => { if (!zTick) { requestAnimationFrame(onZoom); zTick = true; } }, { passive: true });
      window.addEventListener('resize', onZoom, { passive: true });
      onZoom();
    }

    // ── Mat hero: entrance + scroll-driven scale ───────────
    const mathero = $('[data-mathero]');
    if (mathero) {
      // Trigger entrance shortly after load
      requestAnimationFrame(() => setTimeout(() => mathero.classList.add('is-in'), 80));
      const matProduct = mathero.querySelector('[data-mathero-product]');
      if (matProduct) {
        let mTicking = false;
        const onMatScroll = () => {
          const y = window.scrollY;
          const t = Math.min(1, y / (window.innerHeight * 0.9));
          if (!mathero.classList.contains('is-in')) { mTicking = false; return; }
          if (t <= 0.001) {
            // At the top: clear inline transform so the idle float animation runs
            matProduct.style.transform = '';
            matProduct.style.opacity = '';
          } else {
            const scale = 1 + t * 0.12;
            const drift = t * -40;
            const fade = 1 - t * 0.85;
            matProduct.style.transform = `scale(${scale.toFixed(3)}) translateY(${drift.toFixed(1)}px)`;
            matProduct.style.opacity = Math.max(0, fade).toFixed(3);
          }
          mTicking = false;
        };
        window.addEventListener('scroll', () => {
          if (!mTicking) { requestAnimationFrame(onMatScroll); mTicking = true; }
        }, { passive: true });
      }
    }

    // ── Saddle-stitch thread: ONE continuous motion top→bottom ──
    const thread = document.createElement('div');
    thread.className = 'sl-thread';
    thread.setAttribute('aria-hidden', 'true');
    thread.innerHTML =
      '<span class="sl-thread__track"></span>' +
      '<span class="sl-thread__draw"></span>' +
      '<span class="sl-thread__node"></span>';
    document.body.appendChild(thread);
    const draw = thread.querySelector('.sl-thread__draw');
    const node = thread.querySelector('.sl-thread__node');
    let progressTicking = false;
    const updateProgress = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const pct = max > 0 ? Math.min(1, Math.max(0, (h.scrollTop || window.scrollY) / max)) : 0;
      draw.style.transform = `scaleY(${pct.toFixed(4)})`;
      node.style.top = (pct * 100).toFixed(2) + '%';
      // subtle: node pulses brighter near section midpoints handled by CSS
      progressTicking = false;
    };
    window.addEventListener('scroll', () => {
      if (!progressTicking) { window.requestAnimationFrame(updateProgress); progressTicking = true; }
    }, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  // ── MAT DUO: scroll zoom removed (reverted) ──

  // ── Page-wide circular expansion (continues to the end of the page) ──
  if (!reduceMotion) {
    // Persistent mini Shop CTA: show once the hero scroller is scrolled past
    const miniShop = document.querySelector('[data-mini-shop]');
    const heroSec = document.querySelector('[data-scroller]');
    if (miniShop && heroSec) {
      let msTick = false;
      const onMini = () => {
        const past = heroSec.getBoundingClientRect().bottom < window.innerHeight * 0.6;
        const nearFooter = (document.querySelector('.footer')?.getBoundingClientRect().top || 9e9) < window.innerHeight * 0.9;
        miniShop.classList.toggle('show', past && !nearFooter);
        msTick = false;
      };
      window.addEventListener('scroll', () => { if (!msTick) { requestAnimationFrame(onMini); msTick = true; } }, { passive: true });
      onMini();
    }

    // (scroll-progress ring removed)
  }

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-soft-form]');
    if (!f) return;
    e.preventDefault();
    toast(f.dataset.toast || 'Thanks. We\'ll be in touch.');
    f.reset();
  });

  // ── Chalk-dust particle text (hover letters → dust scatters) ──
  const ptext = $('[data-particle-text]');
  if (ptext) {
    // Split into per-letter spans, preserving <br> and spaces
    const html = ptext.innerHTML;
    const parts = html.split(/(<br[^>]*>)/i);
    ptext.innerHTML = '';
    parts.forEach(seg => {
      if (/^<br[^>]*>/i.test(seg)) { ptext.appendChild(document.createElement('br')); return; }
      if (!seg) return;
      seg.split('').forEach(chr => {
        if (chr === ' ') { ptext.appendChild(document.createTextNode('\u00A0')); return; }
        const s = document.createElement('span');
        s.className = 'ch';
        s.textContent = chr;
        ptext.appendChild(s);
      });
    });
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const burst = (el) => {
      if (reduce) return;
      const r = el.getBoundingClientRect();
      const n = 10 + (Math.random() * 6 | 0);
      for (let i = 0; i < n; i++) {
        const p = document.createElement('span');
        p.className = 'chalk-dust';
        const sz = 2 + Math.random() * 5;
        p.style.width = p.style.height = sz + 'px';
        p.style.left = (r.left + Math.random() * r.width) + 'px';
        p.style.top = (r.top + Math.random() * r.height) + 'px';
        p.style.opacity = (0.5 + Math.random() * 0.5).toFixed(2);
        document.body.appendChild(p);
        const ang = Math.random() * Math.PI * 2;
        const dist = 24 + Math.random() * 60;
        const dx = Math.cos(ang) * dist;
        const dy = Math.sin(ang) * dist - 24; // drift up
        const dur = 600 + Math.random() * 700;
        p.animate([
          { transform: 'translate(0,0) scale(1)', opacity: p.style.opacity },
          { transform: `translate(${dx}px, ${dy}px) scale(0.2)`, opacity: 0 }
        ], { duration: dur, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = () => p.remove();
      }
    };
    ptext.querySelectorAll('.ch').forEach(el => {
      el.addEventListener('mouseenter', () => burst(el));
    });
  }

  // ── Bento live clock (Sydney) ─────────────────────────────
  const clock = $('[data-clock]');
  if (clock) {
    const tick = () => {
      try {
        clock.textContent = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        }).format(new Date()) + ' local';
      } catch (e) {
        clock.textContent = new Date().toLocaleTimeString();
      }
    };
    tick();
    setInterval(tick, 1000);
  }

  // ── Buy module: offer selector (preview + Shopify) ────────
  const initBuy = (root = document) => {
  $$('[data-buy]', root).forEach(buy => {
    const priceEl = $('[data-buy-price]', buy), compareEl = $('[data-buy-compare]', buy), quarterEl = $('[data-buy-quarter]', buy);
    const mainImg = $('[data-buy-main]', buy), btn = $('[data-buy-btn]', buy), idsHost = $('[data-buy-ids]', buy);
    const applyOffer = (card, swapImg) => {
      $$('.buy-offer', buy).forEach(c => c.classList.toggle('is-active', c === card));
      const price = parseFloat(card.dataset.price) || 0, compare = parseFloat(card.dataset.compare || '') || 0;
      if (priceEl) priceEl.textContent = '$' + price.toFixed(2) + ' AUD';
      if (compareEl) { compareEl.textContent = compare ? '$' + compare.toFixed(2) : ''; compareEl.style.display = compare ? '' : 'none'; }
      if (quarterEl) quarterEl.textContent = '$' + (price / 4).toFixed(2);
      if (swapImg && mainImg && card.dataset.img) {
        // whole gallery follows the selected mat when the offer carries an image list
        const gal = $('[data-buy-gallery]', buy);
        let list = [];
        try { list = JSON.parse(card.dataset.imgs || '[]'); } catch (e) { list = []; }
        if (gal && gal.setImages && list.length) gal.setImages(list);
        else {
          mainImg.src = card.dataset.img;
          $$('[data-buy-thumb]', buy).forEach(t => t.classList.toggle('is-active', t.dataset.buyThumb === card.dataset.img));
        }
      }
      if (btn && btn.hasAttribute('data-demo-add')) {
        btn.dataset.demoAdd = card.dataset.name; btn.dataset.demoPrice = card.dataset.price;
        if (card.dataset.img) btn.dataset.demoImg = card.dataset.img;
      }
      const tpl = card.querySelector('template[data-buy-inputs]');
      if (idsHost && tpl) { idsHost.innerHTML = ''; idsHost.appendChild(tpl.content.cloneNode(true)); }
    };
    $$('.buy-offer', buy).forEach(card => card.addEventListener('click', () => { if (card.classList.contains('is-soon')) return; applyOffer(card, true); }));
    $$('[data-buy-thumb]', buy).forEach(t => t.addEventListener('click', () => {
      if (mainImg) mainImg.src = t.dataset.buyThumb;
      $$('[data-buy-thumb]', buy).forEach(x => x.classList.toggle('is-active', x === t));
    }));
    const first = $('.buy-offer.is-active', buy) || $('.buy-offer', buy);
    if (first) applyOffer(first, false);
  });
  };
  initBuy();

  // ── Theme editor: re-init + un-hide reveals when a section reloads ──
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target;
    $$('.reveal, [data-stagger]', s).forEach(el => el.classList.add('in-view'));
    if (s.classList && !s.classList.contains('in-view')) s.classList.add('in-view');
    initBuy(s);
  });

  refreshCart();
})();

/* ── Scroll hint: pin under the Shop now button, degrade on short screens ── */
(function(){
  var sc=document.querySelector('[data-scroller]'); if(!sc) return;
  var stage=sc.querySelector('.scroller__stage'), hint=sc.querySelector('.scroller__hint'), btn=sc.querySelector('.sc-shop--open');
  if(!stage||!hint||!btn||hint.classList.contains('scroller__hint--inflow')) return;
  // hint anchors under the LAST element of the bottom group (the italic line now that the CTA sits above it)
  var bot=sc.querySelector('.sc-open .s-open-bot'); if(bot&&bot.lastElementChild) btn=bot.lastElementChild;
  function place(){
    var st=stage.getBoundingClientRect(), b=btn.getBoundingClientRect();
    if(!b.height||!st.height){setTimeout(place,200);return;}
    hint.classList.add('sl-hint-js');
    var btnBot=b.bottom-st.top, txtH=26, space=st.height-btnBot-10;
    if(space>=txtH+6){hint.style.top=(btnBot+10)+'px';hint.style.visibility='';}
    else{
      var grip=sc.querySelector('.sc-open .s-open-bot .s-display');
      var gBot=grip?grip.getBoundingClientRect().bottom-st.top:0;
      var t=(b.top-st.top)-txtH-4;
      if(t>=gBot+2){hint.style.top=t+'px';hint.style.visibility='';}
      else{hint.style.visibility='hidden';}
    }
  }
  window.addEventListener('resize',place,{passive:true});
  window.addEventListener('load',function(){setTimeout(place,60)});
  setTimeout(place,300);
  window.addEventListener('orientationchange',function(){setTimeout(place,120)});
  if(window.visualViewport)visualViewport.addEventListener('resize',place,{passive:true});
})();
